import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-geography',
  templateUrl: './geography.component.html',
  styleUrls: ['./geography.component.scss']
})
export class GeographyComponent implements OnInit {

  gralContent;
  demoContent;
  geoContent;

  constructor() { }

  ngOnInit() {
  }

  toggleGral(){
    this.gralContent = !this.gralContent;
  }
  toggleDemography(){
    this.demoContent = !this.demoContent;
  }
  toggleGeography(){
    this.geoContent = !this.geoContent;
  }

}
